export default __webpack_public_path__ + "static/media/privacy_policy.4aa548d9.pdf";